export const userActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    SET_USERS: 'SET_USERS',
    LOG_OUT: 'LOG_OUT',
    SET_AUTH_ERROR: 'SET_AUTH_ERROR',
    SET_UPDATE_SUCCESS: 'SET_UPDATE_SUCCESS',
    SET_INDICATOR_USERS: 'SET_INDICATOR_USERS',
    SET_WELCOME_MSG: 'SET_WELCOME_MSG',
    SET_CLOSING_MSG: 'SET_CLOSING_MSG',
    SET_PERMISSIONS: 'SET_PERMISSIONS',
    SET_TOKEN: 'SET_TOKEN',
    SET_USER_STATUS: 'SET_USER_STATUS',
    SET_TRANSFER_USER: 'SET_TRANSFER_USER',
    UPDATE_USER_STATUS: 'UPDATE_USER_STATUS',
    SHOW_SESSION_EXPIRED_MODAL: 'SHOW_SESSION_EXPIRED_MODAL',
    HIDE_SESSION_EXPIRED_MODAL: 'HIDE_SESSION_EXPIRED_MODAL',
};